// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// Honorific — source: shared/config/honorific.config.json

export const HONORIFIC_VALUES = ["mr", "mrs", "ms", "mx", "dr", "prof", "rev", "hon", "other"] as const;
export type Honorific = (typeof HONORIFIC_VALUES)[number];

